import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-1 me-3 rounded-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("canvas", { id: "timeChart" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

import { watch } from "vue";
import Chart from "chart.js/auto";
import { onMounted } from "vue";
import formatNormal from "@/js/timeFormat";


export default /*#__PURE__*/_defineComponent({
  __name: 'TimeChart',
  props: ["timeList", "updateChartNum"],
  setup(__props) {

const props = __props;

//* vars
let canvas: any;
let canvasContext: any;
let lineChart: any;

let filteredTimeList = props.timeList.filter((i: any) => !i.addedDnf);

function makeChart() {
    lineChart = new Chart(canvasContext, {
        type: "line",
        options: {
            animation: false,
            scales: {
                y: {
                    beginAtZero: true,
                    ticks: {
                        callback: function (value: any) {
                            return formatNormal(value.toString());
                        },
                        color: "rgba(255,255,255,0.5)",
                    },
                    grid: {
                        color: "rgba(255,255,255,0.5)",
                    },
                },
                x: {
                    grid: {
                        color: "rgba(255,255,255,0.5)",
                    },
                    ticks: {
                        color: "rgba(255,255,255,0)",
                    },
                },
            },
            plugins: {
                tooltip: {
                    callbacks: {
                        label: function (tooltipItem: any) {
                            return formatNormal(tooltipItem.parsed.y.toString());
                        },
                        title: function (tooltipItem: any) {
                            return "";
                        },
                    },
                },
            },
        },
        data: {
            labels: filteredTimeList.map((i: any) => i.num),
            datasets: [
                {
                    label: "Time",
                    data: filteredTimeList.map((i: any) => i.num),
                },
            ],
        },
    });
}

function tryToUpdateChartUntilShown() {
    canvas = document.getElementById("timeChart") as HTMLCanvasElement;
    let i = 0;
    let interval = setInterval(() => {
        i++;
        if (canvas.checkVisibility()) {
            canvasContext = canvas.getContext("2d");
            updateChart();
            clearInterval(interval);
        }
        if (i >= 10) {
            clearInterval(interval);
        }
    }, 100);
}

//* create or update every time timeList changes
function updateChart() {
    if (lineChart) {
        lineChart.data = {
            labels: filteredTimeList.map((i: any) => i.num),
            datasets: [
                {
                    label: "Time",
                    data: filteredTimeList.map((i: any) => i.num),
                },
            ],
        };
        lineChart.update();
    } else {
        try {
            makeChart();
        } catch (e) {
            return;
        }
    }
}

//* create canvas when html is loaded
onMounted(() => {
    tryToUpdateChartUntilShown();
});

//* watching for array change or show timelist on mobile to update chart
watch(
    () => props.timeList,
    () => {
        filteredTimeList = props.timeList.filter((i: any) => !i.addedDnf);

        let newFilteredTimeList = [];
        let i = filteredTimeList.length - 1;
        while (newFilteredTimeList.length < 100) {
            if (i < 0) {
                break;
            }

            newFilteredTimeList.unshift(filteredTimeList[i]);
            i--;
        }

        filteredTimeList = newFilteredTimeList;
        tryToUpdateChartUntilShown();
    },
    { deep: true },
);

//* timeout so it renders after timelist is shown
watch(
    () => props.updateChartNum,
    () => {
        tryToUpdateChartUntilShown();
    },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}
}

})